import axios from 'axios'

import BaseService from '@src/services/BaseService'

class TenantService extends BaseService {
    constructor() {
        super('tenants')
    }

    updateAdminByEmail(id, params) {
        return axios.post(`${this.getUrl()}/${id}/update-by-email`, params)
    }

    updateAdminJustificationLimit(id, params) {
        return this.axios.post(`${this.getUrl()}/${id}/update-justification-limit`, params)
    }
}

export default new TenantService()
